var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCovidTestWhite2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 39,
    r: 34,
    fill: "#08A0A1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 39,
    r: 34,
    fill: "#08A0A1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.7035 28.7275C35.9381 27.7835 30.489 31.631 29.5324 37.3212C28.5759 43.0114 32.4743 48.3896 38.2396 49.3336C44.005 50.2777 49.4541 46.4301 50.4106 40.7399C51.3672 35.0497 47.4688 29.6716 41.7035 28.7275Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3732 39.0685C26.3732 37.8766 25.3942 36.9104 24.1866 36.9104C22.979 36.9104 22 37.8766 22 39.0685C22 40.2604 22.979 41.2266 24.1866 41.2266C25.3942 41.2266 26.3732 40.2604 26.3732 39.0685Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3691 38.6367L28.993 38.6367",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8721 30.0119L31.6213 32.6016",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2778 20.8201C36.039 20.3679 34.6634 20.9924 34.2052 22.215C33.7469 23.4376 34.3797 24.7953 35.6184 25.2475C36.8571 25.6998 38.2328 25.0753 38.691 23.8527C39.1492 22.6301 38.5165 21.2724 37.2778 20.8201Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7471 25.1877L38.6217 28.6406",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4319 23.1347C47.1314 22.9068 45.89 23.7625 45.6591 25.046C45.4282 26.3295 46.2951 27.5547 47.5956 27.7826C48.896 28.0105 50.1374 27.1549 50.3683 25.8714C50.5993 24.5879 49.7323 23.3627 48.4319 23.1347Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4918 27.4142L45.6172 30.0039",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6171 34.3126L49.9932 35.1758",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8321 45.7754C52.6492 45.3112 52.5866 44.7932 52.6523 44.2869C52.718 43.7806 52.9089 43.3087 53.201 42.9309C53.4931 42.5531 53.8732 42.2864 54.2932 42.1645C54.7132 42.0426 55.1544 42.071 55.5608 42.2461C55.9672 42.4211 56.3207 42.735 56.5765 43.148C56.8323 43.5611 56.979 44.0547 56.998 44.5664C57.017 45.0782 56.9074 45.5851 56.6832 46.0231C56.459 46.4611 56.1301 46.8106 55.7382 47.0272C55.2127 47.3171 54.6114 47.3482 54.0665 47.1135C53.5216 46.8788 53.0777 46.3975 52.8321 45.7754V45.7754Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6171 43.8125L49.9932 42.9493",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6872 38.9816C36.7894 38.481 37.0022 38.0314 37.2987 37.6898C37.5953 37.3482 37.9622 37.1298 38.3531 37.0623C38.744 36.9948 39.1414 37.0813 39.495 37.3107C39.8485 37.5401 40.1424 37.9021 40.3394 38.3511C40.5365 38.8001 40.6278 39.3157 40.6019 39.8329C40.576 40.3501 40.4339 40.8456 40.1938 41.2567C39.9537 41.6678 39.6262 41.976 39.2528 42.1425C38.8794 42.3089 38.4768 42.326 38.096 42.1917C37.5854 42.0116 37.1501 41.5722 36.8859 40.9702C36.6217 40.3682 36.5502 39.6528 36.6872 38.9816V38.9816Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4908 50.7187L45.6162 48.1291",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1486 53.0483C35.8359 52.9048 34.6538 53.8388 34.5084 55.1344C34.363 56.43 35.3094 57.5967 36.6221 57.7402C37.9348 57.8837 39.1169 56.9497 39.2623 55.654C39.4077 54.3584 38.4613 53.1918 37.1486 53.0483Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7471 53.3008L37.7471 49.8479",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8721 47.2695L31.6213 45.5431",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4925 39.0648C46.4925 35.4892 43.5556 32.5906 39.9328 32.5906C36.3099 32.5906 33.373 35.4892 33.373 39.0648C33.373 42.6404 36.3099 45.5391 39.9328 45.5391C43.5556 45.5391 46.4925 42.6404 46.4925 39.0648Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 3,
    y: 3,
    width: 79,
    height: 79,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 0,
    y: 0,
    width: 79,
    height: 79,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0352941 0 0 0 0 0.792157 0 0 0 0 0.752941 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCovidTestWhite2);
export default __webpack_public_path__ + "static/media/covid-test-white2.6051a23cc73af35af3af0a02d11a9e9a.svg";
export { ForwardRef as ReactComponent };